// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

  //----------------------------------------------CLient Type ---------------------------------------------------------------
  export const getClientTypeData = createAsyncThunk('appClientType/getClientTypeData', async (params) => {
 const response = await axios.post(' https://api.zasway.com:8443/ClientType/GetTableSummary', params, {mode:'cors'})
 return {
   params,
   data: response.data.data,
   allData: response.data.allData,
   totalPages: response.data.total
 }
})
  

export const getClientTypeEditData = createAsyncThunk('appClientType/getClientTypeEditData', async (params) => {
     
    
    const response = await axios.post(' https://api.zasway.com:8443/ClientType/GetTableSummary', params, {mode:'cors'})
    return {data:response.data.data}
  })

export const resetClientTypeEditData = createAsyncThunk('appClientType/resetClientTypeEditData', async () => {
     
    return {data:[]}
  })

  export const addClientType = createAsyncThunk('appClientType/Create', async (Client) => {
   const response = await axios.post(' https://api.zasway.com:8443/ClientType/Create', Client, {mode:'cors'})
   return response
 })

 export const EditClientType  = createAsyncThunk('appClientType/Update', async (Client) => {
   const response = await axios.post(' https://api.zasway.com:8443/ClientType/Update', Client, {mode:'cors'})
   return response
 })

 export const deleteClientType = createAsyncThunk('appClientType/Delete', async (id) => {
    const response = await axios.post(' https://api.zasway.com:8443/ClientType/Delete', id, {mode:'cors'})
    return response
})
  //-----------------------------------------------End Client Type------------------------------------------------------------

export const ClientTypeSlice = createSlice({
  name: 'appClientType',
  initialState: {
    clientTypeData: [],
    clientTypetotal: 1,
    clientTypeparams: {},
    clientTypeallData: [],
    clientTypeEditData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getClientTypeData.fulfilled, (state, action) => {
        state.clientTypeData = action.payload.data
        state.clientParams = action.payload.params
        state.clientTotal = action.payload.totalPages
      })
     .addCase(getClientTypeEditData.fulfilled, (state, action) => {
            state.clientTypeEditData = action.payload.data
      })
     .addCase(resetClientTypeEditData.fulfilled, (state, action) => {
             
            state.clientTypeEditData = action.payload.data
        })
    }
})


export default ClientTypeSlice.reducer
